import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const TakeImageOptionDialog = (props) => {
  const { visible, onHide, onClickTakePicture, onClickFromGallery } = props;

  return (
    <Dialog
      visible={visible}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      headerClassName="pt-8 pb-0"
      contentClassName="pb-8 pt-1"
      className={`p-fluid !w-[90vw] max-w-[60rem]`}
      onHide={onHide}
      dismissableMask={true}
      closable={false}
    >
      <div className="row-center-center gap-5">
        <Button
          className="col-center-center gap-2 min-h-[6rem] max-w-[8rem]"
          outlined
          onClick={() => {
            if (onClickTakePicture) {
              onClickTakePicture();
            }
          }}
        >
          <i className="pi pi-camera text-3xl" />
          <span>Take Picture</span>
        </Button>
        <Button
          className="col-center-center gap-2 min-h-[6rem] max-w-[8rem]"
          outlined
          onClick={() => {
            if (onClickFromGallery) onClickFromGallery();
          }}
        >
          <i className="pi pi-image text-3xl" />
          <span>From Gallery</span>
        </Button>
      </div>
    </Dialog>
  );
};

export default TakeImageOptionDialog;
